export interface CustomerAgent {
  id: string;
  customerId: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  supplierAddressLine1: string;
  supplierAddressLine2: string;
  supplierAddressLine3: string;
  supplierAddressLine4: string;
  supplierTown: string;
  supplierRegion: string;
  supplierPostcode: string;
  supplierCountry: string;
  supplierSingleLineAddress: string;
  supplierMultiLineAddress: string;
  rate: number;
  obsolete: boolean;
}
